//phonespecs
import specs1 from '../../Images/phonespecsimages/1.jfif'
import specs2 from '../../Images/phonespecsimages/2.jfif'
import specs3 from '../../Images/phonespecsimages/3.jfif'
import specs5 from '../../Images/phonespecsimages/5.jfif'

//parcels management
import parcels2 from '../../Images/parcelsimages/2.jfif'
import parcels4 from '../../Images/parcelsimages/4.jfif'
import parcelsreal3 from '../../Images/parcelsimages/real/3.jpg'
import parcelsreal4 from '../../Images/parcelsimages/real/4.jpg'
import parcelsreal5 from '../../Images/parcelsimages/real/5.jpg'
import parcelsreal6 from '../../Images/parcelsimages/real/6.jpg'
import parcelsreal7 from '../../Images/parcelsimages/real/7.jpg'
import parcelsreal8 from '../../Images/parcelsimages/real/8.jpg'
import parcelsreal10 from '../../Images/parcelsimages/real/10.jpg'
import parcelsreal11 from '../../Images/parcelsimages/real/11.jfif'
import parcelsreal12 from '../../Images/parcelsimages/real/12.jpg'
import parcelsreal13 from '../../Images/parcelsimages/real/13.jpg'

// chat
import chat1 from '../../Images/chatimages/1.jfif'
import chat2 from '../../Images/chatimages/2.jfif'
import chat3 from '../../Images/chatimages/3.jfif'
import chat4 from '../../Images/chatimages/4.jfif'
import chat5 from '../../Images/chatimages/5.jfif'

// cryptoApp
import crypto1 from '../../Images/cryptoimages/1.jfif'
import crypto2 from '../../Images/cryptoimages/2.jfif'
import crypto3 from '../../Images/cryptoimages/3.jfif'

// MealGenerator
import meal1 from '../../Images/mealgeneratorimages/1.jfif'
import meal3 from '../../Images/mealgeneratorimages/3.jfif'
import meal5 from '../../Images/mealgeneratorimages/5.jfif'

// MemoryGame
import memory1 from '../../Images/memoryimages/1.jfif'
import memory2 from '../../Images/memoryimages/2.jfif'

// AngularParcels
import angularparcels1 from '../../Images/angularParcelsImages/1.JPG'
import angularparcels2 from '../../Images/angularParcelsImages/2.JPG'
import angularparcels3 from '../../Images/angularParcelsImages/3.JPG'
import angularparcels4 from '../../Images/angularParcelsImages/4.JPG'
import angularparcels5 from '../../Images/angularParcelsImages/5.JPG'
import angularparcels6 from '../../Images/angularParcelsImages/6.JPG'




import redux from '../../Images/techIcons/redux.svg'
import reactjs from '../../Images/techIcons/reactjs.svg'
import nodejs from '../../Images/techIcons/nodejs.svg'
import mongo from '../../Images/techIcons/mongo.svg'
import css from '../../Images/techIcons/css.svg'
import express from '../../Images/techIcons/express.svg'
import typescript from '../../Images/techIcons/typescript.svg'
import nextjs from '../../Images/techIcons/nextjs.svg'
import angular from '../../Images/techIcons/angular.svg'



const projectsData = [
  {
    id: 1,
    title: 'Full-Stack Chat App',
    description: `Full-Stack Chat Application with users including a database of the
  users and messages, profile images, "unread messages" functionality
  and more`,
    technologies: [
      { src: redux, name: 'REDUX' },
      { src: reactjs, name: 'REACTJS' },
      { src: nodejs, name: 'NODEJS' },
      { src: mongo, name: 'MongoDB' },
      { src: express, name: 'EXPRESS' },
      { src: css, name: 'CSS' },
    ],
    features: {
      frontend: [
        'Register and Login pages',
        'Unread messages functionality(simillar to whatsapp)',
        `Messages Database(messages saves after leaving/logout/exiting the
        browser using MongoDB)`,
        'Users Database(using MongoDB)',
        'Client side validation: Formik, Yup',
        'API calls: axios',
        `React-Redux: Redux persist, Redux toolkit, async api calls from
        redux(async thunk)`,
        'Socket.io',
        'React Router',
        'Profile images uploades using Cloudinary',
        'Chakra-UI',
      ],
      backend: [
        'Express',
        'Authentication: Jsonwebtoken(with middleware)',
        'Bcrypt',
        'MongoDB: Mongoose, Users Database, Messages Database',
        'Socket.io',
        'Cloudinary - for profile images'
      ],
    },
    frontendCodeUrl: 'https://github.com/LiorReuven/ChatFrontend',
    backendCodeUrl:'https://github.com/LiorReuven/ChatBackend',
    demoUrl: 'https://chat-app-lr.netlify.app',
    media: [
      chat1,
      chat2,
      chat3,
      chat4,
      chat5,
    ],
  },
  {
    id: 2,
    title: 'PhoneSpecs',
    description: `Website created to provide phones information and specifications, including 
    search functionality, phones by a specific brand, pagination`,
    technologies: [
      { src: nextjs, name: 'NEXTJS' },
      { src: typescript, name: 'TYPESCRIPT' },
      { src: css, name: 'CSS' },

    ],
    features: {
      frontend: [
        'Written in TypeScript',
        'Search functionality to search for a specific phone',
        `The latest released phones page`,
        'All phone brands page with search functionality',
        'Get all phones by Brand',
        'Pagination implemented(mainly in phones by brand page)',
        `Utilization of pre-render functionality of nextjs`,
        'External api calls',
        'Chakra-UI',
        'Light/Dark Mode',
        'Mobile support',
      ],
      backend: null,
    },
    codeUrl: 'https://github.com/LiorReuven/PhoneSpecs',
    demoUrl: 'https://phone-specs.vercel.app/',
    media: [
      specs1,
      specs2,
      specs3,
      specs5,
    ],
  },
  {
    id: 3,
    title: 'CryptoApp',
    description: `Website created to provide Cryptocurrency information and statistics`,
    technologies: [
      { src: nextjs, name: 'NEXTJS' },
      { src: typescript, name: 'JAVASCRIPT' },
      { src: css, name: 'CSS' },

    ],
    features: {
      frontend: [
        'Top 10 coin page',
        'Details page for a specific coin',
        `Utilization of pre-render functionality of nextjs`,
        'External API calls',
        'Chakra-UI',
        'Light/Dark Mode',
        `Mobile support`,
      ],
      backend: null,
    },
    codeUrl: 'https://github.com/LiorReuven/Cryptocurrency',
    demoUrl: 'https://crypto-app-one-ruddy.vercel.app/',
    media: [
      crypto1,
      crypto2,
      crypto3,
    ],
  },
  {
    id: 4,
    title: 'Meal-Generator App',
    description: `App designed to generate randomly,or specifically search a meal for you, with details,pcitures,ingredients,instructions and a video guide(if available)
    `,
    technologies: [
      { src: nextjs, name: 'REACTJS' },
      { src: typescript, name: 'JAVASCRIPT' },
      { src: css, name: 'CSS' },

    ],
    features: {
      frontend: [
        'React-Router',
        'API calls',
        `Get a randomized meal including image, instructions, ingridients and video guide`,
        'Search functionality to search for a meal',
        'Chakra-UI',
        'Light/Dark Mode',
        `Mobile support`,
      ],
      backend: null,
    },
    codeUrl: 'https://github.com/LiorReuven/MealGenerator',
    demoUrl: 'https://meal-generator-lr.netlify.app/',
    media: [
      meal1,
      meal3,
      meal5,
    ],
  },
  {
    id: 5,
    title: 'Memory Game',
    description: `A ReactJs based memory game
    `,
    technologies: [
      { src: nextjs, name: 'REACTJS' },
      { src: typescript, name: 'JAVASCRIPT' },
      { src: css, name: 'CSS' },

    ],
    features: null,
    codeUrl: 'https://github.com/LiorReuven/MemoryGame',
    demoUrl: 'https://memory-game-lr.netlify.app/',
    media: [
      memory1,
      memory2,
    ],
  },
  {
    id: 6,
    title: 'Parcels Management App',
    description: `I created this application to give a solution for a problem private stores and companies that serve as a delivery pickup-point face,
    there is a lack of management and control over the parcels that go in and out of the store,
     in stores such as the one in the images below, you can have a monthly traffic of thousands of parcels,
    without a management application, the store cannot know how many parcels came in, how many have been released, and from which delivery company. You cannot solve any dispute that may arise. You don't even have a tool that will point you to the correct storage unit of a parcel.
    This parcels management app solves all of that but also more, reducing the average time it takes to give the customer his parcel, preventing potential errors and mistakes from workers at the store,
    and giving full historical data of each parcel that has ever entered the store.`,
    technologies: [
      { src: redux, name: 'REDUX' },
      { src: reactjs, name: 'REACTJS' },
      { src: nodejs, name: 'NODEJS' },
      { src: mongo, name: 'MongoDB' },
      { src: express, name: 'EXPRESS' },
      { src: css, name: 'CSS' },
    ],
    features: {
      general: [
        'Full historical data of every parcel including all vital information',
        'Storage units management allows you to add/edit and assign parcels',
        `Quick parcels release - takes you directly to the proper parcel release form, reducing the waiting time of customers`,
        'Reports - print a monthly report of either all parcels or parcels of a specific delivery company',
        'Multiple error preventing measures(preventing human made errors)',
        'Storage unit auto assigns itself to a specific delivery company based on parcels inserted',
        'Live application - can be opened on multiple computers,changes will be updates automatically(no refresh needed)'
      ],
      technicalities: [
        'Made with ReactJs and NodeJs',
        'MogoDB: Users database, Parcels database, Storage units database',
        `React-Redux: Redux persist, Redux toolkit, async api calls from
        redux(async thunk), multiple global states management and manipulation`,
        'React Howler - for sound queues',
        'React-To-print',
        'Css-Modules',
        'Socket.io',
        'React Router',
        'Authentication: Jsonwebtoken(with middleware)',
        'Bcrypt',
      ]
    },
    frontendCodeUrl: 'https://github.com/LiorReuven/Parcels-Frontend',
    backendCodeUrl: 'https://github.com/LiorReuven/Parcels-Backend',
    demoUrl: '',
    media: [
      parcels4,
      parcels2,
      parcelsreal3,
      parcelsreal4,
      parcelsreal5,
      parcelsreal6,
      parcelsreal7,
      parcelsreal8,
      parcelsreal10,
      parcelsreal11,
      parcelsreal12,
      parcelsreal13,
    ],
  },
  {
    id: 7,
    title: 'Parcels Management App V2.0',
    description: `A newer version of the original parcels management app, done with Angular,
    please visit the original parcels management app page to learn about the core of the app(in main projects page)
    This version added:
    Increased speed and performance,
    Cleaner and more scaleable code,
    Full mobile support,
    Better UI, done with PrimeNG,
    Adding companies and their respective release url feature,
    Exporting reports to Excel / PDF / CSV files,
    Improved filtering and searching in many pages,being able to filter faster and with more options.
    `,
    technologies: [
      { src: angular, name: 'ANGULAR' },
      { src: nodejs, name: 'NODEJS' },
      { src: mongo, name: 'MongoDB' },
      { src: express, name: 'EXPRESS' },
      { src: css, name: 'CSS' },
    ],
    features: {
      general: [
        'Full historical data of every parcel including all vital information',
        'Storage units management allows you to add/edit and assign parcels',
        'Companies management and their respective release url',
        `Quick parcels release - takes you directly to the proper parcel release form, reducing the waiting time of customers`,
        'Reports - export a monthly report of either all parcels or parcels of a specific delivery company to a PDF/EXCEL/CSV file',
        'Multiple error preventing measures(preventing human made errors)',
        'Storage unit auto assigns itself to a specific delivery company based on parcels inserted',
        'Live application - can be opened on multiple computers,changes will be updates automatically'
      ],
      technicalities: [
        'Made with Angular and NodeJs',
        "Angular's rxjs, utilizing http requests,subjects, behavior subjects etc...",
        'MogoDB: Users database, Parcels database, Storage units database',
        'jspdf',
        'Css',
        'Socket.io',
        'Angular Router',
        'Authentication: Jsonwebtoken(with middleware)',
        'Bcrypt',
      ]
    },
    frontendCodeUrl: 'https://github.com/LiorReuven/ParcelsManagementAppV2.0-Front-End',
    backendCodeUrl: 'https://github.com/LiorReuven/ParcelsManagementAppV2.0-Back-End',
    demoUrl: 'https://parcels-management-demo.netlify.app',
    media: [
      angularparcels1,
      angularparcels2,
      angularparcels3,
      angularparcels4,
      angularparcels5,
      angularparcels6

    ],
  },
  
];


export default projectsData